import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { Loader } from '@calendly/ui/components/loader';
import { Control } from '@calendly/ui/components/select';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadTitle, resetTriggerExpand } from 'actions/home_bar/scope_dropdown';
import { useHomeTabs } from 'hooks/home/tabs';
import { forceExpandTriggeredSelector, titleSelector } from 'selectors/home_bar';
import { useScopeControlAvatar } from './use_scope_control_avatar';
const controlCss = "c1xon4mg";
const controlFitContentCss = "c6xlwr6";
const textCropCss = "t18a46e4";
const controlContentCss = "c1wcz9dn";
const controlAvatarCss = "c127ye2q";
const renderControlContent = ({
  title,
  showScopeIcon,
  avatarLetter,
  avatarUrl
}) => {
  if (!title) {
    return <Loader role="status" aria-label={I18n.t('publisher.messages.loading')} />;
  }
  if (!showScopeIcon) {
    return <BodyText className={textCropCss}>{title}</BodyText>;
  }
  return <span className={controlContentCss}>
      <Avatar size="tiny" letter={avatarLetter} src={avatarUrl} aria-hidden tabIndex={-1} className={controlAvatarCss} />
      <BodyText className={textCropCss}>{title}</BodyText>
    </span>;
};
const ScopeDropdownControl = forwardRef(({
  className,
  fitContent = false,
  showScopeIcon = false,
  ...props
}, ref) => {
  const dispatch = useDispatch();
  const title = useSelector(titleSelector);
  const forceExpandTriggered = useSelector(forceExpandTriggeredSelector);
  const {
    getTabScopeV1
  } = useHomeTabs();
  const {
    type,
    id
  } = getTabScopeV1();
  const {
    letter: avatarLetter,
    src: avatarUrl
  } = useScopeControlAvatar();
  useEffect(() => {
    dispatch(loadTitle(type, id));
  }, [dispatch, type, id]);
  useEffect(() => {
    if (!forceExpandTriggered) return;
    const control = ref.current;
    if (control?.getAttribute('aria-expanded') !== 'true') {
      control.click();
    }
    dispatch(resetTriggerExpand());
  }, [forceExpandTriggered, dispatch, ref]);
  const controlLabel = title ? I18n.t('publisher.event_types.scope_dropdown.control_label', {
    scope_name: title
  }) : I18n.t('publisher.event_types.scope_dropdown.control_loading_label');
  return <Control ref={ref} className={classNames(controlCss, {
    [controlFitContentCss]: fitContent
  }, className)} data-calendly-label="scope-button" data-testid="scope-dropdown-control" aria-label={controlLabel} {...props}>
      {renderControlContent({
      title,
      showScopeIcon,
      avatarLetter,
      avatarUrl
    })}
    </Control>;
});
export default ScopeDropdownControl;

require("./control.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./control.js");